import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionPager } from '../components/SectionPager';
import { ExperienceList } from '../components/ExperienceList';
import { Reveal } from '../components/Reveal';
import { earlyCareer } from '../data/experience';
export function Experience() {
  return <>
      <PageHeader number="05" title="Professional Experience" blurb="The full record, from IBM mainframe engineering to the SVP chair." data-id="element-249" data-mp="5k49lxe2e5es" />

      <section className="bg-paper py-16 lg:py-20" data-id="element-250" data-mp="39xkmbtd7lt1p">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-251" data-mp="39yvndlf9smp4">
          <ExperienceList data-id="element-252" data-mp="3nopbu2mv54yb" />
        </div>
      </section>

      <section className="border-t border-navy/10 bg-white py-16 lg:py-20" data-id="element-253" data-mp="3nqaao4g7na1z">
        <div className="mx-auto grid max-w-shell gap-10 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-254" data-mp="3iwed333uzp7c">
          <div className="lg:col-span-4" data-id="element-255" data-mp="2v6bq31esx9fl">
            <Reveal data-id="element-256" data-mp="2q9bfqeax5kio">
              <p className="text-[11px] uppercase tracking-overline text-gold" data-id="element-257" data-mp="2q80f2ncrssvs">1988 — 2001</p>
              <h2 className="mt-5 font-display text-3xl font-light leading-tight text-navy" data-id="element-258" data-mp="3j31om6qfkkw8">
                Earlier career
              </h2>
              <p className="mt-4 text-[14px] leading-relaxed text-steel" data-id="element-259" data-mp="3nzib6whzer77">
                Thirteen years across engineering, technical sales, and product marketing — the
                foundation for later portfolio leadership.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8" data-id="element-260" data-mp="304yuxemxtzs3">
            <ul data-id="element-261" data-mp="352h8xjftb56y">
              {earlyCareer.map((role, i) => <Reveal key={role.title + role.dates} delay={Math.min(i * 0.03, 0.12)} data-id="element-262" data-mp="352qwz1har2a0" data-mpi={i}>
                  <li className="grid gap-2 border-t border-navy/10 py-6 lg:grid-cols-12 lg:gap-6" data-id="element-263" data-mp="3a00lmewv39ws">
                    <span className="text-[11px] uppercase tracking-overline text-steel lg:col-span-3" data-id="element-264" data-mp="3e4qfxzbvggfl">
                      {role.dates}
                    </span>
                    <div className="lg:col-span-9" data-id="element-265" data-mp="tc6js3ngbpxp">
                      <p className="font-display text-xl font-light text-navy" data-id="element-266" data-mp="tf11voizsyny">{role.company}</p>
                      <p className="mt-1 text-[12px] uppercase tracking-overline text-gold" data-id="element-267" data-mp="2qfor6dw556g8">
                        {[role.title, role.location].filter(Boolean).join(' · ')}
                      </p>
                      <p className="mt-2.5 text-[14px] leading-[1.7] text-steel" data-id="element-268" data-mp="2zc63hkg8radk">{role.summary}</p>
                    </div>
                  </li>
                </Reveal>)}
            </ul>
          </div>
        </div>
      </section>

      <SectionPager current="/experience" data-id="element-269" data-mp="22osup3gqpn2n" />
    </>;
}